import { Button } from "@deligoo/ui"
import clsx from "clsx"
import { useHistory } from "react-router-dom"

import { Main } from "@/components/AppLayout"
import { Card } from "@/components/Card"
import { createGenericContext } from "@/utils"

import cls from "./AddManualOrderView.module.scss"
import { CompletionTimeView } from "./steps/CompletionTimeView"
import { DeliveryDataView } from "./steps/DeliveryDataView"
import { OrderKindView } from "./steps/OrderKindView"
import { ParametersView } from "./steps/ParametersView"
import { PickupDataView } from "./steps/PickupDataView"
import { RemainingView } from "./steps/RemainingView"
import { SummaryView } from "./steps/Summary"
import {
  MANUAL_ORDER_FORM_STEPS,
  ManualOrderFormStepKey,
  ManualOrderFormStepLabel,
  useManualOrderForm,
} from "./useManualOrderForm"

const FORM_STEP_VIEWS: Record<ManualOrderFormStepKey, () => JSX.Element> = {
  order_type: OrderKindView,
  pickup_data: PickupDataView,
  delivery_data: DeliveryDataView,
  completion_time: CompletionTimeView,
  parameters: ParametersView,
  remaining: RemainingView,
  summary: SummaryView,
}

export const [useManualOrderFormContext, ManualOrderFormContextProvider] =
  createGenericContext<ReturnType<typeof useManualOrderForm>>()

export const AddManualOrderView = () => {
  const { formStep, ...formContext } = useManualOrderForm()

  const history = useHistory()

  const FormStepView = FORM_STEP_VIEWS[formStep]

  return (
    <Main page pageContrast>
      <div className={cls.header}>
        <Button onClick={() => history.push("/")} color="dark" iconProps={{ name: "chevron-left" }}>
          Powrót do mapy
        </Button>

        <h2>Nowe zlecenie manualne</h2>
      </div>

      <div className={cls.formLayout}>
        <ManualOrderFormContextProvider value={{ formStep, ...formContext }}>
          <FormStepSelect />
          <FormStepView />
        </ManualOrderFormContextProvider>
      </div>
    </Main>
  )
}

const FormStepSelect = () => {
  const { formStep, allowedSteps } = useManualOrderFormContext()

  return (
    <Card className={cls.card}>
      {MANUAL_ORDER_FORM_STEPS.map(({ key, label }, index) => (
        <FormStep
          ordinal={index + 1}
          label={label}
          active={key === formStep}
          disabled={!allowedSteps.some((step) => step.key === key)}
          key={key}
        />
      ))}
    </Card>
  )
}

type FormStepProps = {
  ordinal: number
  label: ManualOrderFormStepLabel
  active: boolean
  disabled: boolean
}

const FormStep = ({ ordinal, label, active, disabled }: FormStepProps) => {
  return (
    <Card.Section className={clsx(cls.formStep, active && cls.active, disabled && cls.disabled)}>
      <div className={cls.ordinal}>{ordinal}</div>
      {label}
    </Card.Section>
  )
}
